import React, { useState } from "react";
import "../css files/Contact.css";

const ContactForm = () => {
  const [status, setStatus] = useState("Submit");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showForm, setShowForm] = useState(true); // Track whether to show the form

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    const { name, email, message } = e.target.elements;
    let details = {
      name: name.value,
      email: email.value,
      message: message.value,
    };
    let response = await fetch("https://mohamedaa-portfolio.onrender.com/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(details),
    });
    setStatus("Submit");
    let result = await response.json();
    if (result.status === "Message Sent") {
      setShowForm(false); // Hide the form
      setShowSuccessMessage(true); // Show success message
      setTimeout(() => {
        setShowSuccessMessage(false); // Hide success message after 2 seconds
      }, 2000);
    }
  };

  return (
    <>
      <div className="contact-page" style={{ textAlign: "center" }}>
        <h1>Contact Me</h1>
        <p>Please feel free to contact me and send me a message below:</p>
      </div>
      {showForm && (
        <form onSubmit={handleSubmit} className="contact-form-container">
          <div className="form-group">
            <label htmlFor="name">Name:</label>
            <input type="text" id="name" required />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input type="email" id="email" required />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message:</label>
            <textarea id="message" required />
          </div>
          <button type="submit">{status}</button>
        </form>
      )}
      {showSuccessMessage && (
        
        <p style={{marginTop:'2%',textAlign:'center'}} className="success-message">Message sent successfully!</p>
      )}
    </>
  );
};

export default ContactForm;

